import { Link } from '@remix-run/react'
import { Download } from 'lucide-react'
import { PAGE_SECTION_IDS, PAGE_SECTION_SCROLL_CLASS } from "~/lib/constants/pageSectionIds";

function EBookSection({ areaSummary }) {
  return (
    <section
      id={PAGE_SECTION_IDS.ebooks}
      className={`bg-orange-50 px-6 py-[60px] rounded-xl border my-8 bg-cover bg-no-repeat ${PAGE_SECTION_SCROLL_CLASS}`}
      style={{
        backgroundImage: `url('${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES || ''}/assets/area-page/banner-audio-book.png')`,
      }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-6" >
        <div className="flex-1">
          <p className="text-xl sm:text-md font-semibold text-gray-800 mb-5 text-center sm:text-left">
            Download Our E-Book
          </p>
          <h2 className="text-3xl text-center md:text-left font-bold text-green-900 mb-4 leading-snug">
            {areaSummary?.blogPosts?.title ||
              <>
                The Ultimate Guide to<br />Private Offices in Sydney
              </>
            }
          </h2>
          {/* Image goes here */}
          <div className="block md:hidden mb-5">
            <img
              src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/area-page/audio-book-cover.avif`}
              alt="The Ultimate Guide"
              className="w-50 mx-auto md:mx-0"
            />
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-wrap">
            <Link to={areaSummary?.blogPosts?.audioUrl} target="_blank" className="w-full sm:w-auto">
              <button className="bg-oh-secondary hover:bg-orange-600 text-white px-4 py-2 rounded-md flex items-center justify-center gap-2 w-full">
                Audio Book
              </button>
            </Link>
            <Link to={areaSummary?.blogPosts?.pdfUrl} target="_blank" className="w-full sm:w-auto">
              <button className="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-md flex items-center justify-center gap-2 w-full">
                <Download className="w-5 h-5" />
                Download PDF
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EBookSection